import React, { useState } from 'react';
import { Card, Input, Button, List, Typography, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Text } = Typography;

function QuestionsPanel({ questions, onAddQuestion, onDeleteQuestion, currentUser, style }) {
  const [newQuestion, setNewQuestion] = useState('');

  const handleSubmit = () => {
    if (newQuestion.trim()) {
      onAddQuestion(newQuestion.trim());
      setNewQuestion('');
    }
  };

  return (
    <Card title="Questions for PO" style={style}>
      <List
        dataSource={questions}
        renderItem={(question) => (
          <List.Item
            actions={[
              question.userId === currentUser && (
                <Button 
                  type="text" 
                  danger 
                  onClick={() => onDeleteQuestion(question.id)}
                >
                  Delete
                </Button>
              )
            ]}
          >
            <List.Item.Meta
              title={question.text}
              description={`Asked by ${question.userName}`}
            />
          </List.Item>
        )}
      />
      <div style={{ marginTop: 16 }}>
        <Input.TextArea
          value={newQuestion}
          onChange={(e) => setNewQuestion(e.target.value)}
          placeholder="Type your question here..."
          autoSize={{ minRows: 2 }}
          onPressEnter={(e) => {
            if (!e.shiftKey) {
              e.preventDefault();
              handleSubmit();
            }
          }}
        />
        <Button 
          type="primary" 
          onClick={handleSubmit}
          style={{ marginTop: 8 }}
          block
        >
          Add Question
        </Button>
      </div>
    </Card>
  );
}

export default QuestionsPanel; 